import type { Syntax } from '../types';

const syntaxMap: Record<string, Syntax> = {
  http: 'url',
  https: 'url',
  ruby: 'ruby',
  php: 'php',
  nodejs: 'javascript',
  java: 'java',
  js: 'javascript',
  jquery: 'javascript',
  react: 'jsx',
  vuejs: 'javascript',
  angular: 'javascript',
  dotnet: 'csharp',
  android: 'java',
  ios: 'swift',

  jsx: 'jsx',
  python: 'python',
  csharp: 'csharp',
};

export const getCodeSyntax = (language: string) => syntaxMap[language] ?? language;
